import { Component, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: "goenga-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.scss"],
})
export class AboutComponent implements OnInit {
  constructor(
    title: Title,
    meta: Meta,) {
    title.setTitle("Over Slagerij Goënga | Echt Texels lamsvlees komt van Slagerij Goënga");
    meta.addTags([
      { name: 'description', content: 'Texelse slagers met een missie sinds 1935.' },
      { name: 'keywords', content: 'lamsvlees, lamsrack, lamsbout,lamskotelet, lamasschouder, lamskarobnade, lamsgehakt, lamsmuis, lamshaas, lamsfilet, lamsrug, lamsham, lamsworst,waddengoud, echt texels, Echt Texels Lamsvlees, lamsvlees bestellen, bestellen, on-line, lam, bezorging door heel Nederland, vers, altijd in voorraad, binnen 24 uur bezorgd,slagerij goenga, Den Hoorn, Texel, kaas, brandnetel, mosterd, peper, boerenkaas, kaas, schapenkaas, wild, echt texels' },
    ]);
  }
  
  ngOnInit() {}
}
